import { render, staticRenderFns } from "./good-shop.vue?vue&type=template&id=bde03606&scoped=true&"
import script from "./good-shop.vue?vue&type=script&lang=js&"
export * from "./good-shop.vue?vue&type=script&lang=js&"
import style0 from "./good-shop.vue?vue&type=style&index=0&id=bde03606&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bde03606",
  null
  
)

export default component.exports